import SwupA11yPlugin from "@swup/a11y-plugin";
import SwupPreloadPlugin from "@swup/preload-plugin";
import Swup from "swup";

const swup = new Swup({
    containers: ["#transition"],
    //     if (url.startsWith('/projekte/')) {
    //         return '/projekte';
    //     }
    //     return url;
    // },
    plugins: [new SwupPreloadPlugin(), new SwupA11yPlugin()],
});

// Close mobile navigation when new page is loaded
swup.hooks.on("page:view", (visit) => {
    document.getElementById("nav-checkbox").checked = false;
});
